import { cn } from 'lib/utils'
import * as React from 'react'

const GradientBox = ({ children, className }: { children: JSX.Element | JSX.Element[]; className?: string }) => {
    return (
        <div className={cn(`bg-gradient-to-r h-full from-accent via-accent/80 to-accent/60 `, className)}>
            {children}
        </div>
    )
}

export default GradientBox
